// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"MenuItem_menu-item__gzRSb","image":"MenuItem_image__1lxdc","menu-name":"MenuItem_menu-name__3TeTd","price":"MenuItem_price__3bY74","edit":"MenuItem_edit__2Agtc"};